<div class="dropdown w-[600px]">
  <div class="dropdown-header flex items-center justify-between">
    <div>
      <div class="dropdown-heading">{{ 'toolbar-notifications-dropdown.notification-list' | translate }}</div>
    </div>
  </div>

  <div class="dropdown-content">
    <mat-tab-group>
      <mat-tab label="{{ 'toolbar-notifications-dropdown.notifications' | translate }}">
        @if ((notificationList$ | async)?.length > 0) {
          @for (notification of notificationList$ | async; track notification) {
            <div
              [class.read]="notification?.viewed"
              class="notification flex items-center h-20 hover:cursor-pointer"
              matRipple
              (click)="sendAction(enumActionType.SHOW, notification); $event.stopPropagation()"
              >
              <div class="flex-auto">
                <div class="notification-label">{{ notification?.message }}</div>
                <div class="notification-description">
                  {{ notification.executeOn | date: 'yyyy-MM-ddTHH:mm:ss.SSSZZZZZ' | relativeDateTime }}
                </div>
              </div>
              <div>
                @if (!notification.viewed) {
                  <button
                    mat-icon-button
                    color="primary"
                    (click)="sendAction(enumActionType.VIEWED, notification); $event.stopPropagation()"
                    >
                    <mat-icon svgIcon="mat:notifications_paused"></mat-icon>
                  </button>
                }
                <button mat-icon-button color="warn" class="red-icon" (click)="sendAction(enumActionType.DELETE, notification); $event.stopPropagation()">
                  <mat-icon svgIcon="mat:delete" class="red-icon"></mat-icon>
                </button>
              </div>
            </div>
          }
        } @else {
          <div class="notification flex items-center justify-center no-notification-bg h-20" [class.read]="true">
            <h4>{{ 'toolbar-notifications-dropdown.no-notifications' | translate }}</h4>
          </div>
        }
      </mat-tab>

      <mat-tab label="{{ 'toolbar-notifications-dropdown.programmed' | translate }}">
        @if ((notificationScheduledList$ | async)?.length > 0) {
          @for (notificationScheduled of notificationScheduledList$ | async; track notificationScheduled) {
            <div
              [class.read]="notificationScheduled?.viewed"
              class="notification flex items-center"
              matRipple
              >
              <div class="flex-auto">
                <div class="notification-label">
                  {{ notificationScheduled?.message }}
                </div>
                <div class="notification-description">
                  {{ notificationScheduled.executeOn | date: 'yyyy/MM/dd HH:mm:ss' }}
                </div>
              </div>
              <button
                mat-icon-button
                color="primary"
                (click)="sendAction(enumActionType.CHANGE_MESSAGE, notificationScheduled); $event.stopPropagation()"
                >
                <mat-icon svgIcon="mat:edit"></mat-icon>
              </button>
              <button mat-icon-button color="primary" class="primary-icon" (click)="sendAction(enumActionType.CHANGE_DATE, notificationScheduled); $event.stopPropagation()">
                <mat-icon svgIcon="mat:edit_calendar" class="primary-icon"></mat-icon>
              </button>
              <button mat-icon-button color="warn" class="red-icon" (click)="sendAction(enumActionType.DELETE, notificationScheduled); $event.stopPropagation()">
                <mat-icon svgIcon="mat:delete" class="red-icon"></mat-icon>
              </button>
            </div>
          }
        } @else {
          <div class="notification flex items-center justify-center no-notification-bg h-20" [class.read]="true">
            <h4>{{ 'toolbar-notifications-dropdown.no-notifications-active' | translate }}</h4>
          </div>
        }

      </mat-tab>
    </mat-tab-group>
  </div>

  <!-- <div class="dropdown-footer flex items-center justify-center">
  <button color="primary" mat-button type="button">MARK ALL AS READ</button>
</div> -->
</div>

<!-- <mat-menu #settingsMenu="matMenu" xPosition="before" yPosition="below">
<button mat-menu-item>
  <mat-icon svgIcon="mat:clear_all"></mat-icon>
  <span>Mark all as read</span>
</button>

<button mat-menu-item>
  <mat-icon svgIcon="mat:notifications_off"></mat-icon>
  <span>Disable Notifications</span>
</button>
</mat-menu> -->
